import logo from '../assets/logo1.png';
import profile from '../assets/profile.png';
import circle from '../assets/circle.png';
import frontend from '../assets/frontend.png';
import backend from '../assets/backend.png';
import database from '../assets/database.png';
import phone from '../assets/phone.png';
import email from '../assets/mail.png';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  logo,
  profile,
  circle,
  frontend,
  backend,
  database,
  phone,
  email,
};
